"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[3727],{

/***/ 32132:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ PrintPayerSelectionModal)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95061);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61800);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24333);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13713);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91241);
/* harmony import */ var _elephant_healthcare_mui_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2550);
/* harmony import */ var _elephant_healthcare_mui_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27832);
/* harmony import */ var elephant_web_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31630);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12850);
/* harmony import */ var elephant_web_style_images_warningIcon_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71813);
/* harmony import */ var _material_ui_icons_Print__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46298);








const useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((theme) => ({
  modal: {
    borderRadius: theme.spacing(3)
  },
  header: {
    backgroundColor: theme.palette.common.white,
    paddingBottom: "0"
  },
  warningMessage: {
    color: theme.palette.grey[600],
    fontWeight: 400,
    marginLeft: theme.spacing(0.5)
  },
  warningIcon: {
    marginRight: theme.spacing(2)
  }
}));
const PrintPayerSelectionModal = ({
  payers,
  onClose,
  onSelection
}) => {
  const classes = useStyles();
  const payerNames = payers.map((p) => {
    var _a;
    return {
      name: ((_a = p == null ? void 0 : p.insuranceDetails) == null ? void 0 : _a.name) || p.name,
      checked: true
    };
  });
  const [selectedPayers, setSelectedPayers] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(payerNames);
  const handleCheckboxChange = (event) => {
    const selected = selectedPayers.map(
      (p) => p.name === event.target.name ? { name: p.name, checked: event.target.checked } : p
    );
    setSelectedPayers(selected);
  };
  const handleSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async () => {
    const selectedPayerNames = selectedPayers.filter((i) => i.checked).map((el) => el.name);
    if (selectedPayerNames.length > 0) {
      onSelection(selectedPayerNames);
    }
    onClose();
  }, [selectedPayers, onClose, onSelection]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(elephant_web_ui__WEBPACK_IMPORTED_MODULE_3__/* .Modal */ .u_, {
    open: true,
    className: classes.modal
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalHeader */ .xB, {
    className: classes.header
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: elephant_web_style_images_warningIcon_svg__WEBPACK_IMPORTED_MODULE_4__,
    alt: "warning",
    className: classes.warningIcon
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    variant: "h5"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    id: "invoices.print.payerselection.title",
    defaultMessage: "Select which invoices to print"
  })))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalBody */ .fe, null, selectedPayers.map((i) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    key: i.name
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    control: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
      name: i.name,
      value: i.name,
      color: "secondary",
      checked: i.checked,
      onChange: handleCheckboxChange
    }),
    label: i.name
  })))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalFooter */ .mz, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_button__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
    color: "tertiary",
    onClick: () => onClose()
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    id: "invoices.print.cancel",
    defaultMessage: "Cancel"
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_button__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
    onClick: handleSubmit,
    color: "primary",
    "data-testid": "invoices.confirmation.accept",
    startIcon: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_icons_Print__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, null)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    id: "invoices.print.accept",
    defaultMessage: "Print Selected"
  }))));
};


/***/ }),

/***/ 45052:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vt": () => (/* reexport */ DeleteInvoiceModal),
  "tN": () => (/* reexport */ Payment/* ExemptModal */.t),
  "vQ": () => (/* reexport */ FinaliseInvoiceModal),
  "RH": () => (/* reexport */ PaymentHistoryModal),
  "XN": () => (/* reexport */ PrintErrorModal),
  "be": () => (/* reexport */ PrintPermissionsModal),
  "_S": () => (/* reexport */ RefundInvoiceModal),
  "zI": () => (/* reexport */ Payment/* TakePaymentModal */.z),
  "it": () => (/* reexport */ VoidInvoiceModal)
});

// UNUSED EXPORTS: TransactionType

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(5427);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-modal@0.3.9_vyafebljftw2lpwbgyprbkkpkm/node_modules/@elephant-healthcare/mui-modal/dist/module.js
var mui_modal_dist_module = __webpack_require__(27832);
// EXTERNAL MODULE: ./src/ui/index.ts + 7 modules
var ui = __webpack_require__(31630);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Check.js
var Check = __webpack_require__(58149);
// EXTERNAL MODULE: ./src/style/images/errorWarning.svg
var errorWarning = __webpack_require__(7440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/__generated__/DeleteInvoiceModal.gql.ts


const defaultOptions = {};
const DeleteInvoiceDocument = lib/* gql */.Ps`
    mutation deleteInvoice($input: DeleteInvoiceInput!) {
  deleteInvoice(input: $input)
}
    `;
function useDeleteInvoiceMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(DeleteInvoiceDocument, options);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/hooks/useFetchPatientInvoices.ts
var useFetchPatientInvoices = __webpack_require__(45277);
// EXTERNAL MODULE: ./src/client/utils/useQuerystring.ts
var useQuerystring = __webpack_require__(19894);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/DeleteInvoiceModal.tsx













const useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  modal: {
    borderRadius: theme.spacing(3)
  },
  header: {
    backgroundColor: theme.palette.common.white,
    alignItems: "center",
    display: "flex"
  },
  warningMessage: {
    color: theme.palette.grey[300],
    fontWeight: 400,
    marginLeft: theme.spacing(0.5)
  },
  warningIcon: {
    marginRight: theme.spacing(2)
  }
}));
lib/* gql */.Ps`
  mutation deleteInvoice($input: DeleteInvoiceInput!) {
    deleteInvoice(input: $input)
  }
`;
const DeleteInvoiceModal = ({
  open,
  onClose,
  invoiceId
}) => {
  const classes = useStyles();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { patientUuid } = (0,useQuerystring/* default */.Z)();
  const [deleteInvoice] = useDeleteInvoiceMutation({
    variables: {
      input: {
        _id: invoiceId
      }
    },
    update: (cache, res) => {
      if (res.data.deleteInvoice) {
        try {
          const cachedInvoices = cache.readQuery({
            query: useFetchPatientInvoices/* QUERY */.Q,
            variables: { patientUuid }
          });
          if (cachedInvoices) {
            cache.writeQuery({
              query: useFetchPatientInvoices/* QUERY */.Q,
              variables: { patientUuid },
              data: {
                invoices: cachedInvoices.invoices.filter(
                  (i) => i._id !== invoiceId
                )
              }
            });
          }
        } catch {
        }
      }
    },
    onError() {
      dist_default().error(
        formatMessage({
          id: "invoicing.deleteInvoice.error.msg",
          defaultMessage: "Failed to delete this invoice"
        })
      );
    },
    onCompleted() {
      dist_default().success(
        formatMessage({
          id: "invoicing.deleteInvoice.success.msg",
          defaultMessage: "Invoice was deleted successfully"
        })
      );
    }
  });
  const [busy, setBusy] = (0,react.useState)(false);
  const handleDeleteInvoice = async () => {
    setBusy(true);
    try {
      await deleteInvoice();
    } finally {
      onClose();
    }
  };
  return /* @__PURE__ */ react.createElement(ui/* Modal */.u_, {
    open,
    className: classes.modal
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement("img", {
    src: errorWarning,
    alt: "warning",
    className: classes.warningIcon
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.delete.modal.subtitle",
    defaultMessage: "Are you sure you want to delete this invoice?"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: () => onClose(),
    disabled: busy
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.delete.cancel",
    defaultMessage: "Cancel"
  })), /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    onClick: handleDeleteInvoice,
    color: "error",
    "data-testid": "invoicing.delete.confirm",
    startIcon: /* @__PURE__ */ react.createElement(Check/* default */.Z, null),
    loading: busy
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.delete.confirm",
    defaultMessage: "Delete Invoice"
  })))));
};
/* harmony default export */ const modals_DeleteInvoiceModal = ((/* unused pure expression or super */ null && (DeleteInvoiceModal)));

// EXTERNAL MODULE: ./src/style/images/warningIcon.svg
var warningIcon = __webpack_require__(71813);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/index.js + 1 modules
var react_intl_lib = __webpack_require__(11313);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/hooks/__generated__/useFinaliseInvoice.gql.ts


const useFinaliseInvoice_gql_defaultOptions = {};
const FinalizeInvoiceDocument = lib/* gql */.Ps`
    mutation finalizeInvoice($input: FinalizeInvoiceInput!) {
  finalizeInvoice(input: $input) {
    _id
    patientType
    created
    updated
    invoiceStatus
    balance {
      total
      paid
      due
      currency
    }
    payers {
      balance {
        total
        paid
        due
        currency
        waived
        exempt
      }
    }
  }
}
    `;
function useFinalizeInvoiceMutation(baseOptions) {
  const options = { ...useFinaliseInvoice_gql_defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(FinalizeInvoiceDocument, options);
}

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/hooks/useFinaliseInvoice.ts




const ERROR_MESSAGE = (0,react_intl_lib/* defineMessage */.Em)({
  id: "invoicing.finaliseInvoice.error.msg",
  defaultMessage: "Failed to finalise this invoice"
});
const SUCCESS_MESSAGE = (0,react_intl_lib/* defineMessage */.Em)({
  id: "invoicing.finaliseInvoice.success.msg",
  defaultMessage: "Invoice was finalised successfully"
});
lib/* gql */.Ps`
  mutation finalizeInvoice($input: FinalizeInvoiceInput!) {
    finalizeInvoice(input: $input) {
      _id
      patientType
      created
      updated
      invoiceStatus
      balance {
        total
        paid
        due
        currency
      }
      payers {
        balance {
          total
          paid
          due
          currency
          waived
          exempt
        }
      }
    }
  }
`;
function useFinaliseInvoice(invoiceId) {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [finaliseInvoice] = useFinalizeInvoiceMutation({
    variables: {
      input: {
        _id: invoiceId
      }
    },
    onError() {
      dist_default().error(formatMessage(ERROR_MESSAGE), {});
    },
    onCompleted() {
      dist_default().success(formatMessage(SUCCESS_MESSAGE), {});
    }
  });
  return { finaliseInvoice };
}

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/FinaliseInvoiceModal.tsx









const FinaliseInvoiceModal_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  modal: {
    borderRadius: theme.spacing(3)
  },
  header: {
    backgroundColor: theme.palette.common.white,
    paddingBottom: "0"
  },
  warningMessage: {
    color: theme.palette.grey[600],
    fontWeight: 400,
    marginLeft: theme.spacing(0.5)
  },
  warningIcon: {
    marginRight: theme.spacing(2)
  }
}));
const FinaliseInvoiceModal = ({
  invoiceId,
  open,
  onClose
}) => {
  const classes = FinaliseInvoiceModal_useStyles();
  const { finaliseInvoice } = useFinaliseInvoice(invoiceId);
  const [busy, setBusy] = (0,react.useState)(false);
  const handleFinalise = async () => {
    setBusy(true);
    try {
      await finaliseInvoice();
    } finally {
      onClose();
    }
  };
  return /* @__PURE__ */ react.createElement(ui/* Modal */.u_, {
    open,
    className: classes.modal
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement("img", {
    src: warningIcon,
    alt: "warning",
    className: classes.warningIcon
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.confirmation.title",
    defaultMessage: "Finalise Invoice?"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h6",
    className: classes.warningMessage
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.confirmation.warning",
    defaultMessage: "Once you finalise you will not be able to do further edits."
  }))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: () => onClose(),
    disabled: busy
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.confirmation.cancel",
    defaultMessage: "Cancel"
  }))), /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    onClick: handleFinalise,
    color: "primary",
    "data-testid": "invoicing.confirmation.accept",
    startIcon: /* @__PURE__ */ react.createElement(Check/* default */.Z, null),
    loading: busy
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.confirmation.accept",
    defaultMessage: "Finalise"
  }))));
};
/* harmony default export */ const modals_FinaliseInvoiceModal = ((/* unused pure expression or super */ null && (FinaliseInvoiceModal)));

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.9/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(85961);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/hooks/__generated__/useVoidInvoice.gql.ts


const useVoidInvoice_gql_defaultOptions = {};
const VoidInvoiceDocument = lib/* gql */.Ps`
    mutation voidInvoice($input: VoidInvoiceInput!) {
  voidInvoice(input: $input) {
    _id
    patientType
    created
    updated
    invoiceStatus
    balance {
      total
      paid
      due
      currency
    }
  }
}
    `;
function useVoidInvoiceMutation(baseOptions) {
  const options = { ...useVoidInvoice_gql_defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(VoidInvoiceDocument, options);
}

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/hooks/useVoidInvoice.ts




const useVoidInvoice_ERROR_MESSAGE = (0,react_intl_lib/* defineMessage */.Em)({
  id: "invoicing.voidInvoice.error.msg",
  defaultMessage: "Failed to void this invoice"
});
const useVoidInvoice_SUCCESS_MESSAGE = (0,react_intl_lib/* defineMessage */.Em)({
  id: "invoicing.voidInvoice.success.msg",
  defaultMessage: "Invoice was voided successfully"
});
lib/* gql */.Ps`
  mutation voidInvoice($input: VoidInvoiceInput!) {
    voidInvoice(input: $input) {
      _id
      patientType
      created
      updated
      invoiceStatus
      balance {
        total
        paid
        due
        currency
      }
    }
  }
`;
function useVoidInvoice(invoiceId) {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [voidInvoice] = useVoidInvoiceMutation({
    onError() {
      dist_default().error(formatMessage(useVoidInvoice_ERROR_MESSAGE), {});
    },
    onCompleted() {
      dist_default().success(formatMessage(useVoidInvoice_SUCCESS_MESSAGE), {});
    }
  });
  const voidUnpaidInvoice = async (reason) => {
    return voidInvoice({
      variables: {
        input: {
          _id: invoiceId,
          reason
        }
      }
    });
  };
  return { voidUnpaidInvoice };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.31.1_react@18.1.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(21235);
// EXTERNAL MODULE: ./node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.31.1/node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(1793);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+react-hook-form-input@0.1.7_sjfm3rrfwwtsx5okgtvvldeidu/node_modules/@elephant-healthcare/react-hook-form-input/dist/module.js
var react_hook_form_input_dist_module = __webpack_require__(29054);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/VoidInvoiceModal.tsx













const REASON = "reason";
const validationSchema = (0,es.object)().shape({
  [REASON]: (0,es.string)().required()
});
const VoidInvoiceModal_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  modal: {
    borderRadius: theme.spacing(3)
  },
  header: {
    backgroundColor: theme.palette.common.white,
    alignItems: "center",
    display: "flex"
  },
  warningIcon: {
    marginRight: theme.spacing(2)
  },
  label: {
    fontSize: "16px",
    color: theme.palette.grey[800],
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px"
    }
  }
}));
const VoidInvoiceModal = ({
  invoiceId,
  open,
  onClose
}) => {
  const classes = VoidInvoiceModal_useStyles();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const formMethods = (0,index_esm/* useForm */.cI)({
    mode: "all",
    reValidateMode: "onChange",
    resolver: (0,yup/* yupResolver */.X)(validationSchema)
  });
  const { voidUnpaidInvoice } = useVoidInvoice(invoiceId);
  const [busy, setBusy] = (0,react.useState)(false);
  const handleVoid = async (values) => {
    setBusy(true);
    try {
      await voidUnpaidInvoice(values.reason);
    } finally {
      onClose();
    }
  };
  const reasonLabel = formatMessage({
    id: "invoicing.void.reason.label",
    defaultMessage: "Please note reason for voiding invoice (max 150 characters)"
  });
  const reasonPlaceholder = formatMessage({
    id: "invoicing.void.reason.placeholder",
    defaultMessage: "Reason for voiding the invoice"
  });
  const handleErrorMessage = (value) => (value == null ? void 0 : value.id) ? formatMessage(value) : value;
  return /* @__PURE__ */ react.createElement(ui/* Modal */.u_, {
    open
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement("img", {
    src: errorWarning,
    alt: "warning",
    className: classes.warningIcon
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.void.modal.title",
    defaultMessage: "You are about to void this invoice"
  })))), /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement("form", {
    name: "void-invoice-form",
    onSubmit: formMethods.handleSubmit(handleVoid)
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle1"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.void.modal.subtitle",
    defaultMessage: "This process is not reversible. Are you sure you want to proceed?"
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* TextField */.nv, {
    name: REASON,
    label: reasonLabel,
    placeholder: reasonPlaceholder,
    disabled: busy,
    required: true,
    multiline: true,
    minRows: 5,
    fullWidth: true,
    helperText: formMethods.formState.touchedFields[REASON] && handleErrorMessage(formMethods.formState.errors[REASON])
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: () => onClose(),
    disabled: busy
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.void.cancel",
    defaultMessage: "Cancel"
  })), /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    type: "submit",
    color: "error",
    "data-testid": "invoicing.void.accept",
    startIcon: /* @__PURE__ */ react.createElement(Check/* default */.Z, null),
    disabled: formMethods.formState.isSubmitting || !formMethods.formState.isValid,
    loading: busy
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.void.confirm",
    defaultMessage: "Void Invoice"
  })))))));
};
/* harmony default export */ const modals_VoidInvoiceModal = ((/* unused pure expression or super */ null && (VoidInvoiceModal)));

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/PrintErrorModal.tsx





const PrintErrorModal = ({
  error,
  onClose,
  onRetry,
  onUseLaser
}) => /* @__PURE__ */ react.createElement(mui_modal_dist_module/* Modal */.u_, {
  open: true,
  onClose
}, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
  title: "Error"
}, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
  variant: "subtitle2"
}, /* @__PURE__ */ react.createElement(message/* default */.Z, {
  id: "invoice.printModal.error.subtitle",
  defaultMessage: "There was an error communicating to the thermal printer"
}))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
  variant: "body2"
}, /* @__PURE__ */ react.createElement(message/* default */.Z, {
  id: "invoice.printModal.error.message",
  defaultMessage: "Please try again, or try laser printing instead."
})), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
  variant: "body2"
}, /* @__PURE__ */ react.createElement("em", null, error.toString()))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
  mr: 2
}, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
  color: "tertiary",
  onClick: onClose
}, /* @__PURE__ */ react.createElement(message/* default */.Z, {
  id: "invoice.printModal.error.actions.cancel",
  defaultMessage: "Cancel"
}))), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
  mr: 2
}, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
  color: "secondary",
  onClick: onUseLaser
}, /* @__PURE__ */ react.createElement(message/* default */.Z, {
  id: "invoice.printModal.error.actions.laser",
  defaultMessage: "Use Laser Printer"
}))), /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
  color: "primary",
  onClick: onRetry
}, /* @__PURE__ */ react.createElement(message/* default */.Z, {
  id: "invoice.printModal.error.actions.retry",
  defaultMessage: "Try Again"
}))));

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/PrintPermissionsModal.tsx






const PrintPermissionsModal = ({
  onClose,
  onConnect,
  onUseLaser
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */ react.createElement(ui/* Modal */.u_, {
    open: true,
    onClose
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    title: formatMessage({
      id: "invoice.printModal.permission.title",
      defaultMessage: "Thermal Printing"
    })
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoice.printModal.permission.subtitle",
    defaultMessage: "We need your permission to access the printer"
  }))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    "data-testid": "thermal-permission"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoice.printModal.permission.message",
    defaultMessage: 'Please click "Connect" and select your printer. You will not be prompted in future.'
  }))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mr: 2
  }, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: onClose
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoice.printModal.permission.actions.cancel",
    defaultMessage: "Cancel"
  }))), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mr: 2
  }, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "secondary",
    onClick: onUseLaser
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoice.printModal.permission.actions.laser",
    defaultMessage: "Use Laser Printer"
  }))), /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "primary",
    onClick: onConnect
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoice.printModal.permission.actions.connect",
    defaultMessage: "Connect"
  }))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(77589);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/TableContainer/TableContainer.js
var TableContainer = __webpack_require__(13153);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Table/Table.js
var Table = __webpack_require__(13510);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/TableHead/TableHead.js
var TableHead = __webpack_require__(45722);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/TableRow/TableRow.js
var TableRow = __webpack_require__(56858);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/TableCell/TableCell.js
var TableCell = __webpack_require__(63550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/TableBody/TableBody.js
var TableBody = __webpack_require__(82842);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/hooks/__generated__/usePaymentHistory.gql.ts


const usePaymentHistory_gql_defaultOptions = {};
const InvoiceDocument = lib/* gql */.Ps`
    query invoice($invoiceId: String!) {
  invoice(invoiceId: $invoiceId) {
    transactions {
      _id
      actionedBy {
        person {
          firstname
          middlename
          lastname
        }
      }
      type
      timestamp
      amount {
        value
        currency
      }
      payment {
        paymentMethod
        authCode
      }
    }
  }
}
    `;
function useInvoiceQuery(baseOptions) {
  const options = { ...usePaymentHistory_gql_defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(InvoiceDocument, options);
}
function useInvoiceLazyQuery(baseOptions) {
  const options = { ...usePaymentHistory_gql_defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(InvoiceDocument, options);
}

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/hooks/usePaymentHistory.ts





lib/* gql */.Ps`
  query invoice($invoiceId: String!) {
    invoice(invoiceId: $invoiceId) {
      transactions {
        _id
        actionedBy {
          person {
            firstname
            middlename
            lastname
          }
        }
        type
        timestamp
        amount {
          value
          currency
        }
        payment {
          paymentMethod
          authCode
        }
      }
    }
  }
`;
const usePaymentHistory_ERROR_MESSAGE = (0,react_intl_lib/* defineMessage */.Em)({
  id: "invoicing.paymentHistory.error.msg",
  defaultMessage: "Failed to get the payment history for this invoice"
});
function usePaymentHistory(invoiceId) {
  const [paymentTransactions, setPaymentTransactions] = (0,react.useState)(null);
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { loading, error, data } = useInvoiceQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      invoiceId
    },
    onError() {
      dist_default().error(formatMessage(usePaymentHistory_ERROR_MESSAGE), {});
    }
  });
  (0,react.useEffect)(() => {
    if (loading || error) {
      return;
    }
    const {
      invoice: { transactions }
    } = data;
    const formattedTransactions = transactions.map((t) => {
      var _a, _b;
      return {
        id: t._id,
        cashier: t.actionedBy.person,
        date: t.timestamp,
        amount: t.amount,
        transactionType: t.type,
        paymentMethod: (_a = t.payment) == null ? void 0 : _a.paymentMethod,
        transactionCode: (_b = t.payment) == null ? void 0 : _b.authCode
      };
    });
    setPaymentTransactions(formattedTransactions);
  }, [loading, error, data]);
  return { loading, error, paymentTransactions };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.16.1/node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(13875);
// EXTERNAL MODULE: ./src/client/utils/useConvertCurrency.js
var useConvertCurrency = __webpack_require__(59807);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/types.ts
var TransactionType = /* @__PURE__ */ ((TransactionType2) => {
  TransactionType2["PAYMENT"] = "PAYMENT";
  TransactionType2["REFUND"] = "REFUND";
  TransactionType2["VOID"] = "VOID";
  TransactionType2["CHARGE_INSURER"] = "CHARGE_INSURER";
  TransactionType2["WAIVER"] = "WAIVER";
  TransactionType2["EXEMPT"] = "EXEMPT";
  return TransactionType2;
})(TransactionType || {});

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/TransactionItem.tsx





const formatTransactionType = (transactionType, paymentMethod) => {
  switch (transactionType) {
    case TransactionType.PAYMENT:
      return `Payment (${paymentMethod})`;
    case TransactionType.EXEMPT:
      return "Exempt";
    case TransactionType.WAIVER:
      return "Waived";
    case TransactionType.CHARGE_INSURER:
      return "Insurer";
    case TransactionType.REFUND:
      return "Refund";
    case TransactionType.VOID:
      return "Void";
    default:
      return "Payment";
  }
};
const TransactionItem_useStyles = (0,makeStyles/* default */.Z)({
  cell: {
    fontSize: "14px"
  }
});
const TransactionItem = ({
  cashier,
  date,
  amount,
  transactionType,
  paymentMethod,
  transactionCode
}) => {
  const classes = TransactionItem_useStyles();
  const penceToPounds = (0,useConvertCurrency/* useConvertFromPenceFactory */.YQ)();
  const { firstname, middlename, lastname } = cashier;
  const cashierName = `${firstname || ""} ${middlename || ""} ${lastname || ""}`;
  return /* @__PURE__ */ react.createElement(TableRow/* default */.Z, null, /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.cell
  }, cashierName), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.cell
  }, (0,format/* default */.Z)(new Date(date), "dd/MM/yyyy HH:mm")), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.cell
  }, penceToPounds((amount == null ? void 0 : amount.value) || 0).toFixed(2))), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.cell
  }, formatTransactionType(transactionType, paymentMethod))), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.cell
  }, transactionCode)));
};

// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/ConditionalDisplay/index.ts + 1 modules
var ConditionalDisplay = __webpack_require__(7195);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/PaymentHistoryModal.tsx










const PaymentHistoryModal_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  modal: {
    borderRadius: theme.spacing(3)
  },
  header: {
    backgroundColor: theme.palette.common.white,
    paddingBottom: "0"
  },
  warningMessage: {
    color: theme.palette.grey[600],
    fontWeight: 400,
    marginLeft: theme.spacing(0.5)
  },
  warningIcon: {
    marginRight: theme.spacing(2)
  },
  tableHeader: {
    fontWeight: 700,
    fontSize: 12,
    color: theme.palette.grey[600],
    fontFamily: theme.typography.fontFamily,
    textTransform: "uppercase"
  }
}));
const PaymentHistoryModal = ({
  invoiceId,
  open,
  onClose,
  currency
}) => {
  const classes = PaymentHistoryModal_useStyles();
  const { paymentTransactions, loading } = usePaymentHistory(invoiceId);
  const paymentsByMpesa = paymentTransactions == null ? void 0 : paymentTransactions.some((p) => p.transactionCode);
  return /* @__PURE__ */ react.createElement(ui/* Modal */.u_, {
    open,
    className: classes.modal
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement("img", {
    src: warningIcon,
    alt: "warning",
    className: classes.warningIcon
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.paymentHistory.title",
    defaultMessage: "Payment History"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, loading ? /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    width: "100%",
    textAlign: "center"
  }, /* @__PURE__ */ react.createElement(CircularProgress/* default */.Z, null)) : /* @__PURE__ */ react.createElement(TableContainer/* default */.Z, null, /* @__PURE__ */ react.createElement(Table/* default */.Z, null, /* @__PURE__ */ react.createElement(TableHead/* default */.Z, null, /* @__PURE__ */ react.createElement(TableRow/* default */.Z, null, /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.tableHeader
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.paymentHistory.header.cashier",
    defaultMessage: "Cashier"
  })), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.tableHeader
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.paymentHistory.header.date",
    defaultMessage: "Date & time"
  })), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.tableHeader
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.paymentHistory.header.amount",
    defaultMessage: "Amount ({currency})",
    values: { currency }
  })), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.tableHeader
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.paymentHistory.header.transactionType",
    defaultMessage: "Transaction"
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: paymentsByMpesa
  }, /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.tableHeader
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.paymentHistory.header.transactionCode",
    defaultMessage: "Transaction Code"
  }))))), /* @__PURE__ */ react.createElement(TableBody/* default */.Z, null, /* @__PURE__ */ react.createElement(react.Fragment, null, paymentTransactions == null ? void 0 : paymentTransactions.map((p) => {
    return /* @__PURE__ */ react.createElement(TransactionItem, {
      key: p.id,
      cashier: p.cashier,
      date: p.date,
      amount: p.amount,
      transactionType: p.transactionType,
      paymentMethod: p.paymentMethod,
      transactionCode: p.transactionCode
    });
  })))))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "primary",
    onClick: () => onClose()
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.paymentHistory.close",
    defaultMessage: "Close"
  })))));
};
/* harmony default export */ const modals_PaymentHistoryModal = ((/* unused pure expression or super */ null && (PaymentHistoryModal)));

// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/hooks/useCurrencyFormatter.ts
var useCurrencyFormatter = __webpack_require__(69775);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/hooks/useRefundInvoice.ts




const useRefundInvoice_ERROR_MESSAGE = (0,react_intl_lib/* defineMessage */.Em)({
  id: "invoicing.refund.error.msg",
  defaultMessage: "Failed to record refund"
});
const useRefundInvoice_SUCCESS_MESSAGE = (0,react_intl_lib/* defineMessage */.Em)({
  id: "invoicing.refund.success.msg",
  defaultMessage: "Payment was refunded successfully"
});
const REFUND_PAYMENT = lib/* gql */.Ps`
  mutation RefundInvoice($input: RefundInvoiceInput!) {
    refundInvoice(input: $input) {
      _id
      created
      updated
      invoiceStatus
      balance {
        total
        paid
        waived
        due
        exempt
        currency
      }
      transactions {
        _id
        actionedBy {
          person {
            firstname
            middlename
            lastname
          }
        }
        type
        timestamp
        amount {
          value
          currency
        }
      }
    }
  }
`;
function useRefundInvoice(invoiceId) {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [saving, setSaving] = (0,react.useState)(false);
  const [saved, setSaved] = (0,react.useState)(false);
  const [makeRefund] = (0,useMutation/* useMutation */.D)(REFUND_PAYMENT, {
    onError() {
      dist_default().error(formatMessage(useRefundInvoice_ERROR_MESSAGE), {});
    },
    onCompleted() {
      setSaving(false);
      setSaved(true);
      dist_default().success(formatMessage(useRefundInvoice_SUCCESS_MESSAGE), {});
    }
  });
  const refundInvoice = (0,react.useCallback)(
    async (values) => {
      setSaving(true);
      await makeRefund({
        variables: {
          input: {
            _id: invoiceId,
            ...values
          }
        }
      });
    },
    [makeRefund, invoiceId]
  );
  return { refundInvoice, saving, saved };
}

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/RefundInvoiceModal.tsx















const RefundInvoiceModal_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  modal: {
    borderRadius: theme.spacing(3)
  },
  header: {
    backgroundColor: theme.palette.common.white,
    paddingBottom: "0"
  },
  totalAmount: {
    marginTop: "4px",
    fontSize: "24px",
    fontWeight: 700
  },
  warningMessage: {
    color: theme.palette.grey[600],
    fontWeight: 400,
    marginLeft: theme.spacing(0.5)
  },
  warningIcon: {
    marginRight: theme.spacing(2)
  }
}));
const RefundInvoiceModal_REASON = "reason";
const AMOUNT_TO_REFUND = "amountToRefund";
const useRefundSchema = ({ totalRefundableInPence }) => {
  const penceToPounds = (0,useConvertCurrency/* useConvertFromPenceFactory */.YQ)();
  return (0,react.useMemo)(
    () => (0,es.object)().shape({
      [RefundInvoiceModal_REASON]: (0,es.string)().required(),
      [AMOUNT_TO_REFUND]: (0,es.number)().required().positive().max(penceToPounds(totalRefundableInPence))
    }),
    [totalRefundableInPence, penceToPounds]
  );
};
const RefundInvoiceModal = ({
  invoiceId,
  open,
  onClose,
  currency,
  totalRefundableInPence
}) => {
  const classes = RefundInvoiceModal_useStyles();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { refundInvoice } = useRefundInvoice(invoiceId);
  const { currencyFormatter } = (0,useCurrencyFormatter/* default */.Z)();
  const penceToPounds = (0,useConvertCurrency/* useConvertFromPenceFactory */.YQ)();
  const poundsToPence = (0,useConvertCurrency/* useConvertFromPoundsFactory */.Pt)();
  const [busy, setBusy] = (0,react.useState)(false);
  const handleErrorMessage = (value) => (value == null ? void 0 : value.id) ? formatMessage(value) : value;
  const handleRefund = async (values) => {
    setBusy(true);
    try {
      await refundInvoice({
        ...values,
        amountToRefund: poundsToPence(values.amountToRefund)
      });
    } finally {
      onClose();
    }
  };
  const amountLabel = formatMessage({
    id: "invoicing.refund.amount.placeholder",
    defaultMessage: "Amount to Refund"
  });
  const reasonLabel = formatMessage({
    id: "invoicing.refund.reason.label",
    defaultMessage: "Reason for refunding the invoice"
  });
  const reasonPlaceholder = formatMessage({
    id: "invoicing.refund.reason.placeholder",
    defaultMessage: "Reason for refunding the invoice"
  });
  const initialValues = (0,react.useMemo)(
    () => ({
      [RefundInvoiceModal_REASON]: void 0,
      [AMOUNT_TO_REFUND]: penceToPounds(totalRefundableInPence)
    }),
    [totalRefundableInPence, penceToPounds]
  );
  const formMethods = (0,index_esm/* useForm */.cI)({
    defaultValues: initialValues,
    resolver: (0,yup/* yupResolver */.X)(useRefundSchema({ totalRefundableInPence })),
    mode: "all",
    reValidateMode: "onChange"
  });
  return /* @__PURE__ */ react.createElement(ui/* Modal */.u_, {
    open,
    className: classes.modal
  }, /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement("form", {
    name: "refund-invoice-form",
    onSubmit: formMethods.handleSubmit(handleRefund)
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement("img", {
    src: warningIcon,
    alt: "warning",
    className: classes.warningIcon
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    gutterBottom: true,
    variant: "h5"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.refund.confirmation.title",
    defaultMessage: "You are about to refund this invoice"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    direction: "row",
    justifyContent: "space-between"
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 4
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.refund.totalAmountLabel",
    defaultMessage: "Amount Paid ({currency})",
    values: {
      currency
    }
  }), /* @__PURE__ */ react.createElement("div", {
    className: classes.totalAmount
  }, currencyFormatter(totalRefundableInPence))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 4
  }, /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* TextField */.nv, {
    inputProps: {
      min: "1",
      step: ".01"
    },
    type: "number",
    name: AMOUNT_TO_REFUND,
    label: amountLabel,
    disabled: busy,
    helperText: formMethods.formState.touchedFields[AMOUNT_TO_REFUND] && handleErrorMessage(
      formMethods.formState.errors[AMOUNT_TO_REFUND]
    ),
    "data-testid": "invoicing.refund.amountToRefund",
    required: true
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* TextField */.nv, {
    name: RefundInvoiceModal_REASON,
    label: reasonLabel,
    placeholder: reasonPlaceholder,
    required: true,
    multiline: true,
    minRows: 5,
    fullWidth: true,
    "data-testid": "invoicing.refund.reason",
    disabled: busy,
    helperText: formMethods.formState.touchedFields[RefundInvoiceModal_REASON] && handleErrorMessage(formMethods.formState.errors[RefundInvoiceModal_REASON])
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: () => onClose(),
    disabled: busy
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.refund.confirmation.cancel",
    defaultMessage: "Cancel"
  }))), /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "primary",
    "data-testid": "invoicing.refund.confirmation.accept",
    startIcon: /* @__PURE__ */ react.createElement(Check/* default */.Z, null),
    loading: busy,
    disabled: formMethods.formState.isSubmitting || !formMethods.formState.isValid,
    type: "submit"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.refund.confirmation.accept",
    defaultMessage: "Refund"
  }))))));
};
/* harmony default export */ const modals_RefundInvoiceModal = ((/* unused pure expression or super */ null && (RefundInvoiceModal)));

// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/Payment/index.ts + 14 modules
var Payment = __webpack_require__(43454);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/index.ts











/***/ }),

/***/ 69775:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useCurrencyFormatter)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var elephant_web_client_utils_useCurrencyFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13856);
/* harmony import */ var elephant_web_client_utils_useConvertCurrency__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59807);



function useCurrencyFormatter() {
  const currency = (0,elephant_web_client_utils_useCurrencyFormat__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  const convertFromPence = (0,elephant_web_client_utils_useConvertCurrency__WEBPACK_IMPORTED_MODULE_2__/* .useConvertFromPenceFactory */ .YQ)();
  const currencyFormatter = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (amountInPence) => currency.format(convertFromPence(amountInPence)),
    [currency, convertFromPence]
  );
  return { currencyFormatter };
}


/***/ }),

/***/ 14344:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TE": () => (/* binding */ usePermissions)
/* harmony export */ });
/* unused harmony exports INVOICING_ROLES, REFUNDING_ROLES */
/* harmony import */ var _elephant_healthcare_user_context_provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36547);
/* harmony import */ var _elephant_healthcare_config_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23198);
/* harmony import */ var _elephant_healthcare_role_definitions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4377);
/* harmony import */ var elephant_web_client_common_featureFlags_FeatureFlagGuard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52937);
/* harmony import */ var elephant_web_client_common_featureFlags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72766);
/* harmony import */ var elephant_web_client_utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20589);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93236);







const {
  CASHOFFICER,
  CLINIC,
  DOCTOR,
  PHARMACIST,
  TECHNICIAN,
  NURSE,
  DISPENSER,
  ADMIN
} = _elephant_healthcare_role_definitions__WEBPACK_IMPORTED_MODULE_2__/* .Role */ .uU;
const INVOICING_ROLES = [
  DOCTOR,
  PHARMACIST,
  TECHNICIAN,
  NURSE,
  DISPENSER
];
const REFUNDING_ROLES = [CLINIC, CASHOFFICER, ADMIN];
function usePermissions() {
  const { roleName } = (0,_elephant_healthcare_user_context_provider__WEBPACK_IMPORTED_MODULE_0__/* .useUserContext */ .SE)();
  const { territory } = (0,_elephant_healthcare_config_provider__WEBPACK_IMPORTED_MODULE_1__/* .useConfig */ .ZR)();
  const paymentsFF = (0,elephant_web_client_common_featureFlags__WEBPACK_IMPORTED_MODULE_4__/* .useFeatureFlag */ .ye)(elephant_web_client_common_featureFlags_FeatureFlagGuard__WEBPACK_IMPORTED_MODULE_3__/* .featureFlags.billing.payments */ .V.billing.payments);
  const blockRefundsFF = (0,elephant_web_client_common_featureFlags__WEBPACK_IMPORTED_MODULE_4__/* .useFeatureFlag */ .ye)(elephant_web_client_common_featureFlags_FeatureFlagGuard__WEBPACK_IMPORTED_MODULE_3__/* .featureFlags.billing.blockRefunds */ .V.billing.blockRefunds);
  const blockWaiveFF = (0,elephant_web_client_common_featureFlags__WEBPACK_IMPORTED_MODULE_4__/* .useFeatureFlag */ .ye)(elephant_web_client_common_featureFlags_FeatureFlagGuard__WEBPACK_IMPORTED_MODULE_3__/* .featureFlags.billing.blockWaive */ .V.billing.blockWaive);
  const exemptionFF = (0,elephant_web_client_common_featureFlags__WEBPACK_IMPORTED_MODULE_4__/* .useFeatureFlag */ .ye)(elephant_web_client_common_featureFlags_FeatureFlagGuard__WEBPACK_IMPORTED_MODULE_3__/* .featureFlags.billing.exemption */ .V.billing.exemption);
  const allowedRoles = roleName === CLINIC || roleName === CASHOFFICER;
  const canFinalise = INVOICING_ROLES.includes(roleName);
  const canRefund = REFUNDING_ROLES.includes(roleName);
  const canVoid = roleName === _elephant_healthcare_role_definitions__WEBPACK_IMPORTED_MODULE_2__/* .Role.ADMIN */ .uU.ADMIN || roleName === CLINIC;
  const isKenya = territory === elephant_web_client_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TERRITORY.KENYA */ .jQ.KENYA;
  const isNigeria = territory === elephant_web_client_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TERRITORY.NIGERIA */ .jQ.NIGERIA;
  return (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(
    () => ({
      refunds: !blockRefundsFF && canRefund,
      waive: !blockWaiveFF,
      exemption: exemptionFF && (isKenya || isNigeria),
      finalise: paymentsFF && canFinalise || allowedRoles,
      void: canVoid
    }),
    [
      blockRefundsFF,
      canRefund,
      blockWaiveFF,
      exemptionFF,
      isKenya,
      isNigeria,
      paymentsFF,
      canFinalise,
      allowedRoles,
      canVoid
    ]
  );
}


/***/ }),

/***/ 79778:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": () => (/* binding */ getPrescriptionLabel),
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var elephant_web_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12823);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52018);
/* harmony import */ var _common_i18n_prescriptions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59028);



const getPrescriptionLabel = ({ prescription = {}, formatMessage }) => {
  const translatedLabel = (0,_common_i18n_prescriptions__WEBPACK_IMPORTED_MODULE_1__/* .getMedicationCodification */ .fN)({
    medication: prescription.medication || {},
    formatMessage
  });
  if (prescription.medication) {
    return translatedLabel;
  }
  return prescription.codification || translatedLabel;
};
const PrescriptionLabel = ({ prescription = {} }) => {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  return getPrescriptionLabel({ prescription, formatMessage });
};
PrescriptionLabel.propTypes = {
  prescription: elephant_web_types__WEBPACK_IMPORTED_MODULE_0__/* .PrescriptionType.isRequired */ .GD.isRequired
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PrescriptionLabel);


/***/ }),

/***/ 67753:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ components_SearchBar)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(5427);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/OutlinedInput/OutlinedInput.js + 1 modules
var OutlinedInput = __webpack_require__(14059);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(66264);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Chip/Chip.js
var Chip = __webpack_require__(82682);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var dist_module = __webpack_require__(46828);
;// CONCATENATED MODULE: ./src/client/components/SearchBar/SearchBar.tsx




const inputStyles = (0,makeStyles/* default */.Z)((theme) => ({
  root: {
    borderRadius: theme.spacing(),
    padding: theme.spacing(2)
  },
  input: {
    padding: theme.spacing(0.5),
    lineHeight: "22px",
    fontWeight: 600
  }
}));
const adornmentStyles = (0,makeStyles/* default */.Z)((theme) => ({
  clearChip: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: theme.spacing(0.5),
    fontWeight: 700
  },
  searchIcon: {
    transform: "scale(0.8)"
  }
}));
function SearchBar({
  value,
  onChange,
  onClear,
  dataTestId = "",
  placeholderText,
  dataTourId = ""
}) {
  const inputClasses = inputStyles();
  const adornmentClasses = adornmentStyles();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */ react.createElement(OutlinedInput/* default */.Z, {
    fullWidth: true,
    id: "component-searchBar",
    autoComplete: "off",
    placeholder: placeholderText,
    endAdornment: /* @__PURE__ */ react.createElement(InputAdornment/* default */.Z, {
      position: "end"
    }, value ? /* @__PURE__ */ react.createElement(Chip/* default */.Z, {
      color: "secondary",
      size: "small",
      "aria-controls": "component-searchBar",
      label: formatMessage({
        id: "component.searchBar.clearActionLabel",
        defaultMessage: "Clear Search"
      }),
      className: adornmentClasses.clearChip,
      onClick: () => onClear()
    }) : /* @__PURE__ */ react.createElement(dist_module.SearchIcon, null)),
    classes: inputClasses,
    value: value != null ? value : "",
    onChange: (event) => onChange(event.target.value),
    "data-testid": dataTestId,
    "data-tourid": dataTourId
  });
}

;// CONCATENATED MODULE: ./src/client/components/SearchBar/index.ts

/* harmony default export */ const components_SearchBar = (SearchBar);


/***/ }),

/***/ 28262:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _auth0_auth0_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14432);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52018);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76653);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79226);
/* harmony import */ var elephant_web_client_auth_auth0_links__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81041);
/* harmony import */ var _auth_SessionTokenProvider_SessionTokenProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1767);
/* harmony import */ var elephant_web_client_auth_SigningTokenProvider_SigningTokenProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48462);








const SignOut = () => {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  const apolloClient = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useApolloClient */ .x)();
  const { clearSessionToken } = (0,_auth_SessionTokenProvider_SessionTokenProvider__WEBPACK_IMPORTED_MODULE_2__/* .useSessionTokenContext */ .ic)();
  const { clearSigningToken } = (0,elephant_web_client_auth_SigningTokenProvider_SigningTokenProvider__WEBPACK_IMPORTED_MODULE_3__/* .useSigningTokenContext */ .M_)();
  const { isAuthenticated, logout } = (0,_auth0_auth0_react__WEBPACK_IMPORTED_MODULE_1__/* .useAuth0 */ .D3)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    sessionStorage.clear();
    apolloClient.clearStore();
    clearSessionToken();
    clearSigningToken();
    if (isAuthenticated) {
      logout({ returnTo: `${window.location.origin}${(0,elephant_web_client_auth_auth0_links__WEBPACK_IMPORTED_MODULE_6__/* .linkToAuth0Login */ .G2)()}` });
    }
  }, [
    apolloClient,
    clearSigningToken,
    clearSessionToken,
    formatMessage,
    isAuthenticated,
    logout
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_7__/* .Navigate */ .Fg, {
    to: (0,elephant_web_client_auth_auth0_links__WEBPACK_IMPORTED_MODULE_6__/* .linkToAuth0Login */ .G2)()
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SignOut);


/***/ }),

/***/ 18513:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(948);
/* harmony import */ var _elephant_healthcare_mui_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40252);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12850);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61800);
/* harmony import */ var elephant_web_client_routes_links__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82303);








const useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((theme) => ({
  h1: {
    textAlign: "center"
  },
  messageWrapper: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
    textAlign: "center",
    display: "inline-block"
  },
  message: {
    fontSize: 15,
    color: theme.palette.grey[400],
    paddingBottom: 20
  },
  root: {
    minHeight: theme.spacing(12),
    flex: 1,
    flexDirection: "column"
  }
}));
const Unauthorized = () => {
  const classes = useStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: classes.root,
    container: true,
    direction: "row",
    justifyContent: "center",
    alignItems: "center"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    variant: "h4",
    component: "h1",
    className: classes.h1,
    color: "inherit"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    id: "unauthorized.title",
    defaultMessage: "You're not authorised to view this page"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classes.messageWrapper
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    variant: "h4",
    component: "h4",
    className: classes.message,
    color: "inherit"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    id: "unauthorized.errorCode",
    defaultMessage: "Error Code: XXX"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    variant: "h4",
    component: "h4",
    className: classes.message,
    color: "inherit"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    id: "unauthorized.message",
    defaultMessage: "Sign in or return to the homepage"
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_link__WEBPACK_IMPORTED_MODULE_1__/* .UnstyledLink */ .H, {
    to: (0,elephant_web_client_routes_links__WEBPACK_IMPORTED_MODULE_6__/* .linkToSignOut */ .Af)()
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    variant: "contained",
    color: "primary"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    id: "unauthorized.logoutBtn",
    defaultMessage: "Sign in"
  }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Unauthorized);


/***/ }),

/***/ 41207:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19036);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1677);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(948);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61800);





const UnauthorizedHeader = ({ classes }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
  className: classes.root,
  container: true,
  direction: "row",
  justifyContent: "center",
  alignItems: "center"
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
  item: true
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
  variant: "h4",
  component: "h1",
  className: classes.h1,
  color: "inherit"
}, "elephant"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
  variant: "h4",
  component: "h4",
  className: classes.h4,
  color: "inherit"
}, "Better for everyone"))));
UnauthorizedHeader.propTypes = {
  classes: prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape({
    h1: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    h4: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    root: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
  }).isRequired
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((theme) => ({
  h1: {
    textAlign: "center"
  },
  h4: {
    textAlign: "center",
    fontSize: 13
  },
  root: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: 66,
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(1),
    color: "white"
  }
}))(UnauthorizedHeader));


/***/ }),

/***/ 39632:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": () => (/* binding */ AppOutOfDateBanner)
/* harmony export */ });
/* harmony import */ var _elephant_healthcare_config_provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23198);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93236);
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59288);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50147);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12850);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76653);
/* harmony import */ var _elephant_healthcare_launchdarkly_provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45309);
/* harmony import */ var elephant_web_client_common_featureFlags__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72766);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61800);









const useIsOutOfDate = (featureEnabled) => {
  const { appOutOfDatePollRateSeconds } = (0,_elephant_healthcare_config_provider__WEBPACK_IMPORTED_MODULE_0__/* .useConfig */ .ZR)();
  const [isOutOfDate, setIsOutOfDate] = react__WEBPACK_IMPORTED_MODULE_1__.useState(false);
  const func = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(
    featureEnabled ? () => fetch("/version").then(
      async (res) => {
        if (await res.text() !== "4.5.3") {
          setIsOutOfDate(true);
        } else {
          setIsOutOfDate(false);
        }
      },
      (reason) => console.error(`Failed to fetch deployed app version ${reason}`)
    ) : () => {
    },
    [featureEnabled]
  );
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    func();
  }, [func]);
  (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_2__/* .useInterval */ .Yz)(func, appOutOfDatePollRateSeconds * 1e3);
  return isOutOfDate;
};
const AppOutOfDateBanner = () => {
  const featureEnabled = (0,_elephant_healthcare_launchdarkly_provider__WEBPACK_IMPORTED_MODULE_4__/* .useFeatureFlag */ .ye)(elephant_web_client_common_featureFlags__WEBPACK_IMPORTED_MODULE_5__/* .featureFlags.appOutOfDateBanner */ .VH.appOutOfDateBanner);
  const isOutOfDate = useIsOutOfDate(featureEnabled);
  const navigate = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_6__/* .useNavigate */ .s0)();
  if (!featureEnabled || !isOutOfDate)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(___WEBPACK_IMPORTED_MODULE_3__/* .WarningBanner */ .r, {
    "data-testid": "app-out-of-date-banner"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    id: "appOutOfDateBanner",
    defaultMessage: "Elephant has been updated. Please <link>refresh your browser</link> to use the latest version.",
    values: {
      link: (text) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("a", {
        href: "#",
        onClick: () => navigate(0)
      }, text)
    }
  })));
};


/***/ }),

/***/ 77501:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": () => (/* binding */ DataSyncBanner)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(69525);
;// CONCATENATED MODULE: ./src/client/components/WarningBanner/DataSyncBanner/hooks/useElapsedTime.ts

const getTimeSince = (startTime) => {
  const since = Math.floor((Date.now() - startTime) / 1e3);
  const minutesSince = Math.floor(since / 60);
  const secondsSince = since - minutesSince * 60;
  return { minutesSince, secondsSince };
};
const useElaspsedTime = (startTime) => {
  const { minutesSince, secondsSince } = getTimeSince(startTime);
  const [{ minutes, seconds }, setElapsed] = (0,react.useState)({
    minutes: minutesSince,
    seconds: secondsSince
  });
  (0,react.useEffect)(() => {
    const interval = setInterval(() => {
      const curr = getTimeSince(startTime);
      setElapsed({ minutes: curr.minutesSince, seconds: curr.secondsSince });
    }, 1e3);
    return () => clearInterval(interval);
  }, [startTime]);
  const displayMins = minutes.toString().padStart(2, "0");
  const displaySeconds = seconds.toString().padStart(2, "0");
  return { minutes, seconds, displayMins, displaySeconds };
};
/* harmony default export */ const useElapsedTime = (useElaspsedTime);

// EXTERNAL MODULE: ./src/client/clinical-engine/data-sync/ClinicalSyncStatus.tsx + 1 modules
var ClinicalSyncStatus = __webpack_require__(75185);
// EXTERNAL MODULE: ./src/client/components/WarningBanner/index.tsx
var WarningBanner = __webpack_require__(50147);
;// CONCATENATED MODULE: ./src/client/components/WarningBanner/DataSyncBanner/index.tsx






const WarningMessage = (0,styled/* default */.Z)("span")(({ theme }) => ({
  color: theme.palette.error.main
}));
const Counter = (0,styled/* default */.Z)("span")(() => ({
  fontWeight: "bold"
}));
const DataSyncBanner = ({ delay }) => {
  const [hasWaited, setHasWaited] = (0,react.useState)(delay == null);
  const { data = {} } = (0,ClinicalSyncStatus/* useClinicalSyncStatusContext */.Tb)();
  const hasData = data && Object.keys(data).length > 0;
  (0,react.useEffect)(() => {
    const timeout = hasData ? setTimeout(() => setHasWaited(true), delay) : null;
    return () => {
      if (timeout)
        clearTimeout(timeout);
    };
  }, [hasData, delay]);
  const offlineSince = Object.values(data).reduce((acc, item) => {
    var _a;
    const createdAt = (_a = item.data) == null ? void 0 : _a.createdAt.getTime();
    return createdAt && createdAt < acc ? createdAt : acc;
  }, Date.now());
  const { displayMins: mins, displaySeconds: secs } = useElapsedTime(offlineSince);
  if (!hasWaited || !hasData) {
    return null;
  }
  return /* @__PURE__ */ react.createElement(WarningBanner/* WarningBanner */.r, {
    "data-testid": "offline-notification"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "offlineStatus.notification.offline.text",
    defaultMessage: "<countdown>{mins}:{secs}</countdown> Unstable connection. Your data is saved locally. Sending data to server, <warning>don't close this window.</warning>",
    values: {
      mins,
      secs,
      warning: (text) => /* @__PURE__ */ react.createElement(WarningMessage, null, text),
      countdown: (text) => /* @__PURE__ */ react.createElement(Counter, {
        "data-testid": "offline-counter"
      }, text)
    }
  }));
};


/***/ }),

/***/ 50147:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": () => (/* binding */ WarningBanner)
/* harmony export */ });
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69525);

const WarningBanner = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("aside")(({ theme }) => ({
  zIndex: 10,
  backgroundColor: theme.palette.warning.main,
  padding: theme.spacing(2)
}));


/***/ })

}]);